/** Stats → Overview → Keywords (A7Y-5020): nine row counts from the keyword dataset, unfiltered. */
import { Table, TableBody, TableHead, TableHeader, TableRow } from '@a7y/tailwind-catalyst';
import type { StatsOverviewBlockMeta, StatsOverviewKeywords } from '@a7y/types';
import { formatInt } from '../format';
import { BlockMetaLine } from './OverviewBlockPanel';
import { Footnote, StatRow } from './parts';

const ALL_SCOPE = '(all stores and environments)';

export function KeywordsBlock({
  body,
  meta,
}: {
  body: StatsOverviewKeywords;
  meta: StatsOverviewBlockMeta;
}) {
  return (
    <div>
      <Table dense striped data-testid="keywords-table">
        <TableHead>
          <TableRow>
            <TableHeader>Line</TableHeader>
            <TableHeader>Count</TableHeader>
            <TableHeader>Source table</TableHeader>
          </TableRow>
        </TableHead>
        <TableBody>
          <StatRow
            testId="kw-distinct-keywords"
            label={`Distinct keywords (term × store × country × language) ${ALL_SCOPE}`}
            value={formatInt(body.distinctKeywordIds)}
            detail="keyword (distinct keyword_id)"
          />
          <StatRow
            testId="kw-distinct-terms"
            label={`Distinct terms ${ALL_SCOPE}`}
            value={formatInt(body.distinctTerms)}
            detail="keyword (distinct term)"
          />
          <StatRow
            testId="kw-suggestion-edges"
            label="Suggestion edges"
            value={formatInt(body.suggestionEdges)}
            detail="suggestion_edge"
          />
          <StatRow
            testId="kw-serp"
            label="SERP observations"
            value={formatInt(body.serpObservations)}
            detail="serp_observation"
          />
          <StatRow
            testId="kw-search-popularity"
            label="Search-popularity observations"
            value={formatInt(body.searchPopularityObservations)}
            detail="search_popularity_observation"
          />
          <StatRow
            testId="kw-volume"
            label="Volume observations"
            value={formatInt(body.volumeObservations)}
            detail="volume_observation"
          />
          <StatRow
            testId="kw-provider"
            label="Provider observations"
            value={formatInt(body.providerObservations)}
            detail="provider_observation"
          />
          <StatRow testId="kw-term-tags" label="Term tags" value={formatInt(body.termTags)} detail="term_tag" />
          <StatRow
            testId="kw-tracked"
            label="Project tracked-keyword rows"
            value={formatInt(body.projectTrackedKeywords)}
            detail="project_tracked_keyword"
          />
        </TableBody>
      </Table>
      <BlockMetaLine meta={meta} testId="kw-meta" />
      <Footnote testId="kw-distinct-note">
        The two distinct lines count every row in the keyword table, whatever its store or environment. The
        Keyword Database page counts only App Store and Play Store rows in production, so its totals are smaller.
      </Footnote>
    </div>
  );
}
